/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AccountStatus {
    DISABLED = 'Disabled',
    ACTIVE = 'Active',
    LIMITED = 'Limited',
    BLACK_LISTED = 'BlackListed',
    SUSPICIOUS = 'Suspicious',
}
